import styled from 'styled-components'
import { Tabs, Dialog, DialogTitle, DialogContent } from '@mui/material'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 64px); // Subtract topbar height
  width: 100%;
  background: #fff;
  padding: 20px;
  overflow: hidden;
  box-sizing: border-box;
`

export const TabsContainer = styled.div`
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 20px;
  flex-shrink: 0;
`

export const StyledTabs = styled(Tabs)`
  .MuiTab-root {
    text-transform: none;
    font-size: 14px;
    padding: 12px 16px;
    min-width: 0;
    margin-right: 24px;
    color: #666;

    &.Mui-selected {
      color: #000;
      font-weight: 500;
    }
  }
`

export const ControlsBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-shrink: 0;
`

export const SearchAndFilter = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const SearchInput = styled.input`
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  width: 200px;
  font-size: 14px;

  &::placeholder {
    color: #999;
  }
`

export const FilterText = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
  font-size: 14px;
  cursor: pointer;
`

export const AddTaskButton = styled.button`
  background: none;
  border: none;
  color: #2196f3;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    text-decoration: underline;
  }
`

export const TasksTable = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  width: 100%;
`

export const TableContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  width: 100%;
`

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  width: 16px;
  height: 16px;
  cursor: pointer;
  appearance: none;
  background: white;
  outline: none;
  position: relative;

  &:checked {
    background-color: #4caf50;
    border-color: #4caf50;

    &::after {
      content: '✓';
      color: white;
      font-size: 11px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`

export const TaskRow = styled.div`
  display: grid;
  grid-template-columns: 24px 2fr 1fr 1fr 1fr 1fr auto;
  gap: 12px;
  padding: 12px 16px;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
  color: #333;
  width: 100%;
  box-sizing: border-box;

  & > * {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
  }

  ${props =>
    props.$completed &&
    `
     color: #999;
     background-color: #fafafa;

     & ${Checkbox} {
       background-color: #4CAF50;
       border-color: #4CAF50;

       &::after {
         content: '✓';
         color: white;
         font-size: 11px;
         position: absolute;
         top: 50%;
         left: 50%;
         transform: translate(-50%, -50%);
       }
     }
   `}
`

export const HeaderRow = styled(TaskRow)`
  color: #666;
  font-weight: normal;
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;
  border-bottom: 2px solid #e0e0e0;
  margin: 0;
  flex-shrink: 0;
`

export const DueDate = styled.span`
  color: ${props => (props.$isOverdue ? '#f44336' : 'inherit')};
`

export const TaskNameCell = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
  padding-right: 20px;

  &:hover {
    color: #2196f3;

    &::after {
      content: '→';
      position: absolute;
      right: 0;
      opacity: 1;
    }
  }

  &::after {
    content: '→';
    position: absolute;
    right: 0;
    opacity: 0;
    transition: opacity 0.2s ease;
    color: #2196f3;
  }
`

export const SortableHeaderCell = styled.div`
  cursor: pointer;
  position: relative;
  padding-right: 20px;

  &::after {
    content: '${props => {
      if (props.$sortDirection === 'asc') return '↑'
      if (props.$sortDirection === 'desc') return '↓'
      return '↕'
    }}';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    opacity: ${props => (props.$sortDirection ? 1 : 0.5)};
  }

  &:hover::after {
    opacity: 1;
  }
`

export const TaskDetailsModal = styled(Dialog)`
  .MuiDialog-paper {
    min-width: 500px;
    max-width: 800px;
  }
`

export const ModalTitle = styled(DialogTitle)`
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
`

export const ModalContent = styled(DialogContent)`
  padding: 24px;
`
